import { Injectable } from '@angular/core';
import { AuthMode, environment } from '../../environments/environment';

/**
 * Single source of truth for the active authentication mode.
 *
 * Wraps `environment.AUTH_MODE` so callers don't need to read from the
 * environment directly and can use semantic helpers instead.
 */
@Injectable({ providedIn: 'root' })
export class AuthModeService {
  private readonly mode: AuthMode = environment.AUTH_MODE;

  get current(): AuthMode {
    return this.mode;
  }

  isIdp(): boolean {
    return this.mode === 'IDP';
  }

  isCot(): boolean {
    return this.mode === 'COT';
  }
}
